export default {
  white: '#FFF',
  black: '#000',
  primary: '#59c0a5',
  secondary: '#b8846c',
  copperGradient: { start: '#b87b5d', end: '#ce9072' },
  gray: '#D0D0D0',
}
